export const NavBarLinks =[
    {
        title:"Home",
        path : "/",
    },
    {
        title:"Courses",
        path:"/courses",
    },
    {
        title:"Upload",
        path:"/upload",
    },
    {
        title:"Contact Us",
        path:"/contact",
    },


]